import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Key } from "lucide-react";

const LABELS = {
  lifes_work: "Life's Work",
  evolution: "Evolution",
  radiance: "Radiance",
  purpose: "Purpose",
};

export const GeneKeysCard = ({ geneKeys, details = [] }) => {
  if (!geneKeys) return null;
  const detailByKey = Object.fromEntries(details.map((d) => [d.slot, d]));
  const items = Object.entries(LABELS).map(([k, label]) => ({
    key: k, label, gate: geneKeys[k], detail: detailByKey[k],
  }));
  return (
    <Card
      data-testid="gene-keys-card"
      className="border-white/10 bg-[#111625]/80 backdrop-blur-xl text-[#F8FAFC] h-full"
    >
      <CardHeader className="pb-3">
        <CardTitle className="font-serif-mystic text-2xl flex items-center gap-2">
          <Key size={18} strokeWidth={1.5} className="text-[#D4AF37]" />
          Gene Keys
        </CardTitle>
        <p className="text-xs uppercase tracking-[0.2em] text-[#94A3B8]">Four Prime Gifts</p>
      </CardHeader>
      <CardContent>
        <ul className="grid grid-cols-2 gap-3">
          {items.map((it) => (
            <li
              key={it.key}
              data-testid={`gk-${it.key}`}
              className="rounded-lg border border-white/5 bg-[#05070A]/40 p-3"
            >
              <p className="text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]">{it.label}</p>
              <p className="font-serif-mystic text-3xl mt-1">{it.gate || "—"}</p>
              {it.detail && (
                <div className="mt-2 space-y-0.5 text-[10px]">
                  <p className="text-red-300/80">Shadow · {it.detail.shadow}</p>
                  <p className="text-[#D4AF37]">Gift · {it.detail.gift}</p>
                  <p className="text-[#2ED199]">Siddhi · {it.detail.siddhi}</p>
                </div>
              )}
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};
